/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DESKTOP_BREAKPOINT = 1024;
var BACKSPACE_CODE = 8;
var ESCAPE_CODE = 27;
var ZipCodeSearch = function () {
  function ZipCodeSearch($) {
    var _this = this;
    _classCallCheck(this, ZipCodeSearch);
    $(window).resize(function () {
      _this.isMobile = window.innerWidth < DESKTOP_BREAKPOINT;
      _this.checkViewport($);
    });
    $(window).on('load', function () {
      _this.init($);
      _this.setPacContainerInsideLocationSearchContainer($);
    });
  }
  return _createClass(ZipCodeSearch, [{
    key: "init",
    value: function init($) {
      var _this2 = this;
      this.isMobile = window.innerWidth < DESKTOP_BREAKPOINT;
      this.zipCodeField = $('#zip-code');
      this.locationSearchContainer = $('#location-search-container');
      var _this$zipCodeField = _slicedToArray(this.zipCodeField, 1),
        zipCodeInput = _this$zipCodeField[0];
      this.zipCodeInput = zipCodeInput;
      this.url = new URL(window.location);
      this.storedLocation = this.url.searchParams.get('location');
      this.useCurrentLocationButtons = document.querySelectorAll('.use-current-location');
      this.providersLocationSearchBar = document.querySelector('.field--name-field-find-prov-loc-search-bar');
      if (this.providersLocationSearchBar) {
        this.dumpedLabels = this.providersLocationSearchBar.querySelector('.dumped-labels');
        if (this.dumpedLabels) {
          this.currentLocationLabel = this.dumpedLabels.querySelector('.field--name-field-current-location-label').textContent;
        }
      } else {
        this.dumpedLabels = document.querySelector('.page-find-a-provider .dumped-labels');
        if (this.dumpedLabels) {
          this.currentLocationLabel = this.dumpedLabels.querySelector('.field--name-field-current-location-label').textContent;
        }
      }
      if (this.storedLocation && this.zipCodeInput) {
        this.zipCodeInput.value = this.storedLocation;
        this.useCurrentLocationButtons.forEach(function (button) {
          button.setAttribute('style', 'display:none;');
        });
      }
      this.clearZipButton = $('.clear-zip-button');
      this.locationClear = $('#location-clear');
      this.locationBack = $('#location-back');
      var loader = new google.maps.plugins.loader.Loader({
        apiKey: 'AIzaSyB_-JON1px4G3i047DSm_A3YX6DJzGlXpY',
        libraries: ['places']
      });
      loader.load().then(function (google) {
        var autocomplete = new google.maps.places.Autocomplete(_this2.zipCodeInput, {
          types: ['(regions)']
        });
        google.maps.event.addListener(autocomplete, 'place_changed', function () {
          _this2.place = autocomplete.getPlace();
          var locationParam = _this2.zipCodeInput.value;
          if (locationParam) {
            _this2.url = new URL(window.location);
            _this2.url.searchParams.set('location', locationParam);
            sessionStorage.removeItem('userCurrentLatLng');
            window.history.pushState({}, '', decodeURIComponent(_this2.url));
          }
          ZipCodeSearch.removeMobileOverlay($);
          _this2.showHideUseMyLocationAndClose(null);
        });
      });
      this.locationClear.click(function () {
        var $zipCode = $('#zip-code');
        $zipCode.val('');
        sessionStorage.removeItem('userCurrentLatLng');
        _this2.url = new URL(window.location);
        _this2.url.searchParams.delete('location');
        window.history.pushState({}, '', decodeURIComponent(_this2.url));
        $zipCode[0].style.fontWeight = 'normal';
        _this2.showHideUseMyLocationAndClose(null, true);
      });
      this.clearZipButton.click(function () {
        var $zipCode = $('#zip-code');
        $zipCode.val('');
        sessionStorage.removeItem('userCurrentLatLng');
        _this2.url = new URL(window.location);
        _this2.url.searchParams.delete('location');
        window.history.pushState({}, '', decodeURIComponent(_this2.url));
        $zipCode[0].style.fontWeight = 'normal';
        _this2.showHideUseMyLocationAndClose(null, true);
      });
      this.zipCodeField.click(function () {
        _this2.showHideUseMyLocationAndClose(null, false);
      });
      this.useCurrentLocationButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          navigator.geolocation.getCurrentPosition(function (res) {
            sessionStorage.setItem('userCurrentLatLng', JSON.stringify({
              lat: res.coords.latitude,
              lng: res.coords.longitude
            }));
            var $zipCode = $('#zip-code');
            $zipCode.val(_this2.currentLocationLabel);
            ZipCodeSearch.removeMobileOverlay($);
            $zipCode[0].style.fontWeight = 'bold';
            _this2.showHideUseMyLocationAndClose(null);
          });
        });
      }, function (error) {
        console.error(error);
      });
    }
  }, {
    key: "setPacContainerInsideLocationSearchContainer",
    value: function () {
      var _setPacContainerInsideLocationSearchContainer = _asyncToGenerator(_regeneratorRuntime().mark(function _callee($) {
        var pacContainer;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              pacContainer = $('.pac-container')[0];
              if (!pacContainer) {
                _context.next = 5;
                break;
              }
              $(this.locationSearchContainer).append(pacContainer);
              _context.next = 9;
              break;
            case 5:
              _context.next = 7;
              return new Promise(function (resolve) {
                setTimeout(function () {
                  return resolve();
                }, 1000);
              });
            case 7:
              _context.next = 9;
              return this.setPacContainerInsideLocationSearchContainer($);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setPacContainerInsideLocationSearchContainer(_x) {
        return _setPacContainerInsideLocationSearchContainer.apply(this, arguments);
      }
      return setPacContainerInsideLocationSearchContainer;
    }()
  }, {
    key: "checkViewport",
    value: function checkViewport($) {
      var zipCodeField = $('#zip-code');
      if (this.isMobile) {
        zipCodeField.focus(function () {
          ZipCodeSearch.addMobileOverlay($);
        });
      } else {
        zipCodeField.focus(function () {
          ZipCodeSearch.removeMobileOverlay($);
        });
      }
    }
  }, {
    key: "getDistanceZipInputFromLeftSideOfWindow",
    value: function getDistanceZipInputFromLeftSideOfWindow() {
      var fieldLeftPadding = 20;
      var pixelsFromLeft = this.zipCodeField[0].getBoundingClientRect().left;
      return pixelsFromLeft + fieldLeftPadding;
    }
  }, {
    key: "inputIsActuallyFilled",
    value: function inputIsActuallyFilled(e) {
      var zipIsFilled = this.zipCodeField[0].value.length > 1;
      if (e) {
        return e.keyCode !== BACKSPACE_CODE && e.keyCode !== ESCAPE_CODE || zipIsFilled;
      }
      return zipIsFilled;
    }
  }, {
    key: "hideCloseAndShowUseLocation",
    value: function hideCloseAndShowUseLocation() {
      this.useCurrentLocationButtons.forEach(function (button) {
        button.style.removeProperty('display');
      });
      if (this.locationClear[0]) {
        this.locationClear[0].style.removeProperty('display');
      }
    }
  }, {
    key: "setSearchFontWeight",
    value: function setSearchFontWeight(e) {
      if (this.inputIsActuallyFilled(e)) {
        this.zipCodeField[0].style.fontWeight = 'bold';
      } else {
        this.zipCodeField[0].style.fontWeight = 'normal';
      }
    }
  }, {
    key: "mobileOverlayInactive",
    value: function mobileOverlayInactive() {
      var overlayActive = this.locationSearchContainer[0].classList.contains('location-search-container--active');
      return !overlayActive;
    }
  }, {
    key: "showHideUseMyLocationAndClose",
    value: function showHideUseMyLocationAndClose(e) {
      var clearClicked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!clearClicked) {
        if (this.inputIsActuallyFilled(e)) {
          if (this.mobileOverlayInactive()) {
            this.useCurrentLocationButtons.forEach(function (button) {
              button.style.display = 'none';
            });
          }
          if (this.locationClear[0]) {
            this.locationClear[0].style.display = 'block';
          }
        } else {
          this.hideCloseAndShowUseLocation();
        }
      } else {
        this.hideCloseAndShowUseLocation();
      }
    }
  }, {
    key: "setListeners",
    value: function setListeners($) {
      var _this3 = this;
      if (this.zipCodeField) {
        this.zipCodeField.keydown(function (e) {
          _this3.setSearchFontWeight(e);
          _this3.showHideUseMyLocationAndClose(e);
        });
        this.locationBack.click(function () {
          ZipCodeSearch.removeMobileOverlay($);
          _this3.showHideUseMyLocationAndClose(null);
        });
      }
    }
  }], [{
    key: "setBackButtonWidth",
    value: function setBackButtonWidth($) {
      var labelWidth = $('#zip-code-label').outerWidth(true);
      $('#location-back')[0].style.width = "".concat(labelWidth, "px");
    }
  }, {
    key: "addMobileOverlay",
    value: function addMobileOverlay($) {
      $('.conditions').addClass('conditions--inactive');
      $('.location-search-container').addClass('location-search-container--active');
      var homepageBanner = $('.paragraph--type--hero-banner.paragraph--view-mode--home-page');
      if (homepageBanner) {
        homepageBanner.addClass('zip-search-bar--mobile-search');
      }
      $('.site-header').addClass('zip-search-bar--mobile-search');
      $('.search-bar').addClass('zip-search-bar--mobile-search');
      $('body').css({
        position: 'fixed'
      });
      ZipCodeSearch.setBackButtonWidth($);
    }
  }, {
    key: "removeMobileOverlay",
    value: function removeMobileOverlay($) {
      $('.conditions').removeClass('conditions--inactive');
      $('.location-search-container').removeClass('location-search-container--active');
      var homepageBanner = $('.paragraph--type--hero-banner.paragraph--view-mode--home-page');
      if (homepageBanner) {
        homepageBanner.removeClass('zip-search-bar--mobile-search');
      }
      $('.site-header').removeClass('zip-search-bar--mobile-search');
      $('.search-bar').removeClass('zip-search-bar--mobile-search');
      $('body').css({
        position: 'relative'
      });
    }
  }]);
}();
export { ZipCodeSearch as default };
(function ($) {
  var zipCodeField = $('#zip-code');
  if (zipCodeField) {
    var zipCodeSearch = new ZipCodeSearch($);
    zipCodeSearch.checkViewport($);
    zipCodeSearch.setListeners($);
  }
})(jQuery, Drupal);